export default "__VITE_ASSET__a31b11a3__"